ckdc.require( [ 'setup', 'Vimeo' ], function(){
    function update_player_position( player ) {
	var p_time = null;
	var p_duration = null;
	
	try {
	    p_time = player.getCurrentTime();

	    if ( typeof player.video_duration != "undefined" && player.video_duration > 0 ) {
		p_duration = player.video_duration;
	    } else {
		p_duration = player.getDuration().then( function( seconds ) {
		    player.video_duration = seconds;
		} );
	    }

	    Promise.all( [p_time, p_duration] ).then( function( values ) {
		var time = values[0];
		var duration = values[1];

		if ( typeof time == 'undefined' || ! time || typeof duration == 'undefined' || ! duration ) {
		    return;
		}
		
		var position = ( time * 100 ) / duration;
		if ( position > 90 ) {
		    position = 100;
		} else if ( position > 73 ) {
		    position = 75;
		} else if ( position > 48 ) {
		    position = 50;
		} else if ( position > 23 ) {
		    position = 25;
		} else if ( position > 8 ) {
		    position = 10;
		} else {
		    position = 1;
		}

		if ( typeof player.video_position != 'undefined' && player.video_position == position ) {
		    return;
		}

		player.video_position = position;

		jQuery.post( ckdc.ajaxurl, {
		    action: 'ckdc_video_position',
		    post_id: player.ckdc_post_id,
		    nonce: player.ckdc_post_nonce,
		    pos: position,
		}, function () {} );
	    } );
	} catch( e ) {
	    return;
	}
    }
    
    function check_player_texttracks( player ) {
	    // enable swedish subtitles on swedish site default
	    var currentLanguage = ckdc.html.data( 'language' );
	    if('sv' == currentLanguage) {
		    player.enableTextTrack('sv');
		}
    }

    function setup_player( iframe ) {
	var $iframe = jQuery( iframe );

	try {
	    var player = new Vimeo.Player( iframe );
	} catch( e ) {
	    return;
	}

	check_player_texttracks( player );

	var post_id = $iframe.data( 'postid' );
	if ( typeof post_id == 'undefined' || ! post_id > 0 ) {
	    return;
	}
	
	var post_nonce = $iframe.data( 'postnonce' );
	if ( typeof post_nonce == 'undefined' || ! post_nonce > 0 ) {
	    return;
	}

	player.ckdc_post_id = post_id;
	player.ckdc_post_nonce = post_nonce;

	var player_interval = null;

	player.on( 'play', function( data ) {
	    update_player_position( player );

	    player_interval = setInterval( update_player_position, 5000, player );
	} );
	
	player.on( 'pause', function( data ) {
	    update_player_position( player );
	    
	    if ( player_interval != null ) {
		clearInterval( player_interval );
		player_interval = null;
	    }
	} );
	
	player.on( 'ended', function( data ) {
	    update_player_position( player );
	    
	    if ( player_interval != null ) {
		clearInterval( player_interval );
		player_interval = null;
	    }
	} );
    
    }

    var iframes = jQuery( '.iframe-vimeo iframe' );

    if ( ! iframes.length ) {
	return;
    }

    iframes.each( function( i, e ) {
	setup_player( e );
    } );
    
});
